import * as THREE from "three";

export const createSolarPanelTexture = (): THREE.CanvasTexture => {
  const textureSize = 128;
  const numCells = 16;
  const cellColor = "#1a1a3a";
  const borderColor = "#FFFFFF";
  const borderWidth = 1;
  const cornerCellSize = 2; // 2x2

  const canvas = document.createElement("canvas");
  canvas.width = textureSize;
  canvas.height = textureSize;
  const context = canvas.getContext("2d");

  if (!context) {
    console.error("Failed to get 2D context for texture generation");
    return new THREE.CanvasTexture(canvas);
  }

  // --- Draw the full grid first (as before) ---
  context.fillStyle = borderColor;
  context.fillRect(0, 0, textureSize, textureSize);

  const totalBorderWidth = (numCells + 1) * borderWidth;
  const cellSize = (textureSize - totalBorderWidth) / numCells;

  if (cellSize <= 0) {
    console.error("Calculated cell size is too small. Adjust parameters.");
    return new THREE.CanvasTexture(canvas);
  }

  context.fillStyle = cellColor;
  for (let row = 0; row < numCells; row++) {
    for (let col = 0; col < numCells; col++) {
      const x = borderWidth + col * (cellSize + borderWidth);
      const y = borderWidth + row * (cellSize + borderWidth);
      context.fillRect(x, y, cellSize, cellSize);
    }
  }
  // --- End drawing full grid ---

  // --- Clear the corner sections ---
  // Calculate the pixel size of the area to clear in each corner.
  // It's the size occupied by cornerCellSize cells + their borders.
  // Size = cornerCellSize * cellSize + (cornerCellSize + 1) * borderWidth (approx)
  // Simpler: Each cell slot (cell + border) approx size = textureSize / numCells
  const slotSize = textureSize / numCells; // Size of one cell slot (e.g., 64/8 = 8)
  const clearSize = cornerCellSize * slotSize; // Size of the square area to clear (e.g., 2 * 8 = 16)

  // Top-Left
  context.clearRect(0, 0, clearSize, clearSize);
  // Top-Right
  context.clearRect(textureSize - clearSize, 0, clearSize, clearSize);
  // Bottom-Left
  context.clearRect(0, textureSize - clearSize, clearSize, clearSize);
  // Bottom-Right
  context.clearRect(
    textureSize - clearSize,
    textureSize - clearSize,
    clearSize,
    clearSize
  );
  // --- End clearing corners ---

  const texture = new THREE.CanvasTexture(canvas);
  texture.needsUpdate = true;
  return texture;
};
